import React, { useCallback, useEffect, useContext } from 'react';
import { MenuContext, PathContext } from '../App';
import useLocalStorage from '../hooks/useLocalstorage';
import { Content } from '../components/Layout';
import { HeaderContainer, Buttons } from '../style';
import { PageHeader, Button } from 'scorer-ui-kit';
import styled from 'styled-components';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const Container = styled(Content) <{ marginLeft?: string }>`
  display: flex;
  flex: 1;
  margin-left: ${({ marginLeft }) => marginLeft ? marginLeft : '295px'};
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 60px 700px 25px 50px;
  transition: 0.2s;
`;

const TasksetView = () => {
  const { setSelectedStep } = useContext(MenuContext);
  const { pathUpdated } = useContext(PathContext);
  const { floorPlanStorage } = useLocalStorage();

  /*---------route---------*/
  const onContinue = useCallback((index: number) => {
    setSelectedStep(index);
  }, [setSelectedStep]);

  useEffect(() => {
    if (pathUpdated) { setSelectedStep(3); }
  }, [pathUpdated, setSelectedStep]);
  /*---------route---------*/
  return (
    <Container>
      <HeaderContainer>
        <PageHeader title='オペレーター一覧' areaHref='/' />
        <Buttons>
          <Button design='primary' size='small' onClick={() => onContinue(10)}>編集</Button>
        </Buttons>
      </HeaderContainer>

      <TableContainer component={Paper}>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell align='center'>id</TableCell>
              <TableCell align='center'>オペレーター名</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {floorPlanStorage.operators.map((operator: any) => {
              return (
                <TableRow key={operator.id}>
                  <TableCell align='center'>{operator.id}</TableCell>
                  <TableCell align='center'>{operator.name}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default TasksetView;
